.pad {
  background: #fff;
  border: 1px solid rgba(8, 18, 12, 0.12);
  border-radius: var(--token-radius-drawing-pad);
  box-shadow: var(--token-shadow-drawing-pad);
  touch-action: none;
  cursor: crosshair;
  display: block;
}

/* Disabled pad — same visual frame as the live pad, but no canvas
 * underneath. Drops the crosshair and lets pointer events pass
 * through so they don't intercept the board's pen overlay or the
 * surrounding live-page nav. */
.padDisabled {
  cursor: default;
  pointer-events: none;
}
